import { addKeyboardBinding } from "../util/ui/Keyboard";
export function setupCustomCheckbox(checkboxId, checkmarkId) {
    const checkbox = document.getElementById(checkboxId);
    const checkmark = document.getElementById(checkmarkId);
    addKeyboardBinding({ code: "Space" }, () => checkbox.click(), checkmark);
    return checkbox;
}
